import { Component } from '@angular/core';

@Component({
  selector: 'nec-footer-copyright',
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.scss']
})
export class NecCopyrightComponent {
}
